import React, { useEffect, useState } from 'react'
import HeroBanner from '../component/Common Banner Component/HeroBanner'
import TextContent from '../component/TextContent/TextContent'
import Footer from '../component/Footer/Footer'
import PlainText from '../component/PlainText/PlainText'
import OurTeam from '../component/OurTeam/OurTeam'
import Header from '../component/Header/Header'
import ContactForm from '../component/ContactForm/ContactForm'
import Contactform from '../component/Contact Form/Contactform'
import { Helmet } from 'react-helmet'

function About() {
    const [bgImg,setBgImg]  = useState('/images/creatives/about-hero-bg.png')

    useEffect(()=>{
      if(window.innerWidth <= 992)
      {
        setBgImg("/images/creatives/about-hero-bg-mob.png")
      }
    },[])
  return (
    <div>
      <Helmet>
        <title>
        Tina Doney - Founder & CEO - Mobile Laser Therapy.
        </title>
        {/* <meta name="keywords" 
        content=""
        ></meta> */}
        <link
          rel="canonical"
          href="https://www.mobilelasertherapy.ca/about"
        />
        <meta
          name="description"
          content="Tina Doney, founder of Mobile Laser Therapy, is a seasoned physiotherapist with advanced expertise in orthopaedic manual therapy. Inspired by her own injury, she brings BIOFLEX® Laser Therapy to clients for pain relief and healing."
        ></meta>
      </Helmet>
       
        <div style={{backgroundColor:"#F4FEFD"}}>
            <Header/>
        </div>
        <div style={{position:"relative",zIndex:"-1"}}>
            <img src={bgImg} alt='about us page hero' style={{width:"100%"}}/>
            <div className='container About-hero-bg-resp'>
                <h3 className='hero-section-heading text-center' style={{color:'white',textShadow:"1px 0 white"}}>ABOUT US</h3>
            </div>
        </div>

        <div style={{backgroundColor:"#F4FEFD"}} className='py-5'>
            <TextContent
                subHeading=""
                subPara="Founder & CEO"
                heading= "Tina Doney"
                content={"I began my career in physiotherapy after graduating from McMaster University in 1994.\n After graduating with degrees in Honours Bachelor of Physical Education and Honours Bachelor of Health Sciences in Physiotherapy, I have since achieved the highest standard in Orthopaedic Clinical Education recognized by the Physiotherapy Association, an Advanced Diploma in Orthopaedic Manual and Manipulative Physiotherapy. As a former collegiate athlete I sustained a torn ACL in 1991 that required surgery. This injury gave me an appreciation for physiotherapists and the importance of helping people reduce their pain, and to help them heal as quickly and as safely as possible. This inspired me into a wonderful and fulfilling career.  My team and I want to save you time and provide convenience. We will bring  Laser Therapy to your home, workplace or facility to eliminate pain, reduce inflammation and help you heal."}
                btn={false}
                btnText=""
                btnRef=''
                shiftRow={true}
                img="/images/creatives/about-text-1.png"
                reviewContent={false}
                btnImg={false}
                fontDark={true}
                lineBetween={false}
                txtAnchor={false}
            />
        </div>

        <OurTeam />
        

        <TextContent
            subHeading=""
            subPara=""
            heading= "What is Laser Therapy?"
            content={"The benefits of Laser Therapy are proven in more than 4,000 scientific papers and 500 clinical studies. The BIOFLEX® Laser Therapy system that we use utilizes scientifically developed and clinically tested protocols that maximize the effectiveness of treatment of an extensive range of clinical pathologies. Laser Technology uses superluminous and laser diodes to treat diseased or traumatized tissue with photons. These particles of energy are selectively absorbed by the cell membrane and intracellular molecules, initiating a cascade of complex physiological reactions, leading to the restoration of normal cell structure and function."}
            btn={true}
            btnText="Read More"
            btnRef='/what-we-treat'
            shiftRow={false}
            img="/images/creatives/service-text-1.png"
            reviewContent={false}
            btnImg={false}
            fontDark={true}
            lineBetween={false}
            txtAnchor={false}
            lazerPictureText={true}
            lazerContentFirst={true}
        />

       <Contactform/>

        <Footer 
        newsletterSection={false}
        />

    </div>
  )
}

export default About